import {Base64} from 'js-base64'
import moment from 'moment'
import {filterDate, filterMoney, formatMoney, formatPercent, formatToPercent} from '@/filters/index'
import {getToken, getMenuId, setMenuId} from '@/utils/auth'

export default {
    data() {
        return {
            loading: false, // 遮罩层
            ids: '', // 多选id
            tableData: [], // 表格数据
            total: 0, // 列表总数
            currentPage: 1,
            listUrl: '', // 列表地址,
            params: {},
            downloadLoading:false,//导出加载
            checkedList: [], // 选中的对象
            state: false,
            roleParams: {},
            ReleaseVersion: 'V201803221254',
            collects: {},
            moreCondition: false,
        }
    },
    methods: {
        //移除重复标签
        removeDuplicatesTags(tags) {
            let newTagArr = []
            for (let tag of tags) {
                let midlleTag = newTagArr.find((newTag) => {
                    return tag.code === newTag.code
                })
                if (!midlleTag) {
                    console.log(midlleTag, 'midlleTag')
                    newTagArr.push(tag)
                }
            }
            return newTagArr
        },
        // 下载excel
        downloadExcel(busiCode, queryList) {
            this.downloadLoading=true;
            this.$fetchData('/api/doExcel/exportCreate/' + busiCode, queryList, 'post').then(res => {
                console.log("res", res)
                if (res && res.fastdfspath) {
                    location.href = '/api/doExcel/exportDownLoad?path=' + res.fastdfspath + '&name=' + res.filename
                }
                this.downloadLoading=false;
            }).catch(err=>{
                this.downloadLoading=false;
            })
        },
        // 下载excel
        downloadExcelPage(busiCode, queryList) {
            this.downloadLoading=true;
            this.$fetchData('/api/doExcel/exportCreatePage/' + busiCode, queryList, 'post').then(res => {
                console.log("res", res)
                if (res && res.fastdfspath) {
                    location.href = '/api/doExcel/exportDownLoad?path=' + res.fastdfspath + '&name=' + res.filename
                }
                this.downloadLoading=false;
            }).catch(err=>{
                this.downloadLoading=false;
            })
           
        },
        initTableData(url, params, nomemory) {
            this.params = params
            //存储查询条件及分页信息
            if (!nomemory) {

                // if (localStorage.getItem("querypage" + this.$route.path + Base64.encode(this.$route.query))) {
                //   params = JSON.parse(localStorage.getItem("querypage" + this.$route.path + Base64.encode(this.$route.query)));
                //   if (params.page != undefined) {
                //     // this.currentPage = params.page
                //   }
                // }

                if (params.page != undefined) {
                    // this.params.page = params.page
                }
                if (params.pageSize != undefined) {
                    this.params.pageSize = parseInt(params.pageSize)
                }
                if (params.orderBy != undefined) {
                    this.params.orderBy = params.orderBy
                }
                if (params.export != undefined) {
                    this.params.export = params.export
                }
                if (params.queryParamList != undefined) {
                    for (let i = 0; i < params.queryParamList.length; i++) {
                        if (params.queryParamList[i].save == undefined || params.queryParamList[i].save) {
                            for (let j = 0; j < this.params.queryParamList.length; j++) {
                                if (params.queryParamList[i].field == this.params.queryParamList[j].field) {
                                    this.params.queryParamList[j].value = params.queryParamList[i].value;
                                    this.params.queryParamList[j].items = params.queryParamList[i].items;
                                    break;
                                }
                            }
                        }

                    }
                }
            }
            /*console.log("querypage"+this.$route.path+Base64.encode(this.$route.query));
            console.log(JSON.stringify(params));*/
            this.listUrl = url
            if (!nomemory) {
                this.getTableData(this.params)
            } else {
                this.getTableData(this.params, 'application/x-www-form-urlencoded')
            }
        },
        getTableData(params, contentType) {
            // 获取表格数据
            this.loading = true
            this.state = false
            //存储查询条件及分页信息
            if (params.page) {

                localStorage.setItem("querypage" + this.$route.path + Base64.encode(this.$route.query), JSON.stringify(params));
            }

            this.$fetchData(this.listUrl, params, 'post', contentType)
                .then(res => {
                    this.tableData
                    this.loading = false
                    if (res.totalRows != undefined) {
                        this.total = res.totalRows
                    }
                    if (res.collects) {
                        this.collects = res.collects;
                    }
                    this.tableData = res.content
                    this.state = true
                }).catch(error => {
                this.loading = false
                this.state = false
            })
        },
        getRoleTableData(roleParams) {
            // 获取表格数据
            this.loading = true
            this.state = false
            this.$fetchData(this.$api.fwRoleList.queryPage, roleParams, 'post')
                .then(res => {
                    this.loading = false
                    if (res.totalRows != undefined) {
                        this.total = res.totalRows
                    }


                    this.roleData = res.content
                    this.state = true
                })
                .catch(error => {
                    this.loading = false
                    this.state = false
                })
        },
        getPages(page, pageSize) {
            // 获取翻页数据
            this.params.page = page
            this.currentPage = page
            this.params.pageSize = pageSize
            this.getTableData(this.params)
        },
        getRolePages() {
            this.roleParams.page = page
            this.roleParams.pageSize = pageSize
            this.getRoleTableData(this.roleParams)
        },
        query() {
            // 条件查询
            this.params.page = 1;
            this.currentPage = 1;
            this.getTableData(this.params)
        },
        clear(form) {
            // 清空
            this.$refs[form].resetFields()
        },
        checkIds(val) {
            let ids = []
            for (let i in val) {
                ids.push(val[i].id)
            }
            this.ids = ids
            this.checkedList = val
        },
        deleteBatch(url, ids) {
            if (ids) {//兼容老cms单个删除和批量删除
                // 删除
                if (ids instanceof Array) {
                    ids = ids.join(",")
                }
                this.$confirm('是否确定删除？', '警告', {type: 'error'})
                    .then(res => {
                        this.$fetchData(url, {ids: ids}, 'post', "application/x-www-form-urlencoded").then(res => {
                            if (res.code == 200) {
                                this.$message.success('删除成功')
                                this.getTableData(this.params)
                            } else {
                                this.$message.error('删除失败')
                            }
                        })
                    })
                    .catch(error => {
                    })
            } else {
                // 删除
                if (!this.ids.length) {
                    this.$message.error('您还没有选择数据')
                    return
                }
                this.$confirm('是否确定删除？', '警告', {type: 'error'})
                    .then(res => {
                        this.$fetchData(url, this.ids, 'post').then(res => {
                            if (res) {
                                this.$message.success('删除成功')
                                this.getTableData(this.params)
                            }
                        })
                    })
                    .catch(error => {
                    })
            }

        },
        jumpPageBatch(route, type = 'update', noselectCheck) {
            localStorage.setItem("route", 0)
            // 页面跳转
            if (!noselectCheck) {
                if (type !== 'new') {
                    if (!this.ids.length) {
                        this.$message.error('您还没有选择数据')
                        return
                    } else if (this.ids.length > 1) {
                        this.$message.error('只能选择一条数据')
                        return
                    }
                }
            }
            if (route.query) {
                this.$router.push({path: route.path, query: route.query})
            } else {
                this.$router.push({path: route.path})
            }
        },
        jumpPageNoselect(route, type = 'update') {
            if (route.query) {
                this.$router.push({path: route.path, query: route.query})
            } else {
                this.$router.push({path: route.path})
            }
        },
        jumpPagePreview(route, noselectCheck) {
            if (route.query) {
                this.$router.push({path: route.path, query: route.query})
            } else {
                this.$router.push({path: route.path})
            }
        },
        dobluClick(row, event) {
            this.$refs.eltable.toggleRowSelection(row)
        },
        btnVisiable(btnKey) {
            let allMenu = this.$store.getters.allMenus;
            for (let i = 0; i < allMenu.length; i++) {
                if (allMenu[i].url === btnKey) {
                    if (allMenu[i].isShow == 1) {
                        return true;
                    } else {
                        return false;
                    }

                }
            }
            return false;
        },
        getClaimVisiable(key, orgId) {
            if (orgId == null || orgId == '') {
                return false;
            } else {
                return this.$fetchData(this.$api.configList.checkKeyAndOrgId + "/" + key + "/" + orgId,
                    {}, 'get').then(res => {
                    return res
                });
            }
        },
        prioritysBatchs(url, ids, priorities, disableds, regDefId) { //保存排列循序四个参数
            this.$confirm('是否保存排序？', '提示', {type: "warning"})
                .then(mes => {

                    this.$fetchData(url, {
                        ids: this.ids.join(","),
                        priorities: priorities,
                        disableds: disableds,
                        defId: regDefId
                    }, "post", "application/x-www-form-urlencoded").then(res => {
                        if (res.code == "200") {
                            this.$message.success('操作成功');
                            this.getTableData(this.params);
                        }
                    });
                })
                .catch(error => {
                });
        },
        //列缩进展开
        fixedShow() {
            if (this.tableFixedShow == true) {
                this.tableFixedShow = false
            } else {
                this.tableFixedShow = true
            }
        },
        showTableFixed(val) {
            var count = 0;
            for (var i = 0; i < this.columns.length; i++) {
                if (this.columns[i].prop == val) {
                    this.columns.splice(i, 1);
                    for (var j = 0; j < this.temps.length; j++) {
                        if (this.temps[j].prop == val) {
                            this.temps[j].show = ''
                        }
                    }
                    count++
                }
            }
            if (count == 0) {
                for (var j = 0; j < this.temps.length; j++) {
                    if (this.temps[j].prop == val) {
                        this.columns.splice(j, 0, this.temps[j])
                        this.temps[j].show = '√';
                    }
                }
            }
        },
        //beforeRouteEnter用初始化列表方法
        vmInitList(url, param, vm) {
            this.loading = true;
            this.listUrl = url;
            this.$fetchData(url, param, 'post')
                .then(res => {
                    this.loading = false
                    if (res.totalRows != undefined) {
                        this.total = res.totalRows
                    }
                    this.$set(this, 'tableData', res.content)
                    this.state = true
                }).catch(error => {
                this.loading = false
                this.state = false
            })
        },
        getFwCols(columns) {
            let oldMenuId = getMenuId();
            let fwCols = this.$store.state.permission.fwCols[oldMenuId]
            console.log("fwCols : ", fwCols)
            let newColumns = [];
            if (fwCols) {
                if (fwCols.length > 0) {
                    newColumns = [];
                    for (let fwCol of fwCols) {
                        for (let column of columns) {
                            if (fwCol.name === column.prop) {
                                newColumns.push(column)
                                break;
                            }
                        }
                    }
                } else {
                    newColumns = columns
                }
            }
            return newColumns;
        },
        sortMethodTime(a,b,type){
            if(null == a[type]){
                a[type] = ''
            }
            if(null == b[type]){
                b[type] = ''
            }
            if(a[type]<b[type]){
                return -1;
            }else{
                return 1;
            }
        },
        /*'yyyy-MM-dd HH:mm:ss'格式的字符串转日期*/
        stringToDate(date) {
            return moment(date).toDate();
        },
        filterDate: filterDate,
        filterMoney: filterMoney,
        formatMoney: formatMoney,
        formatPercent: formatPercent,
        formatToPercent: formatToPercent,
        openSelfColumn() {
            this.$nextTick(() => {
                this.$refs['self-column'].loadInitData();
            })
        },
        openCondition() {
            this.moreCondition = true
        },
        closeCondition() {
            this.moreCondition = false
        },
    }
}
